import { getOrganizationsRequest, getProjectsRequest } from '../services/organisations';

export const useOrganizations = () => {
  const getOrganizations = async () => {
    const organizations = await getOrganizationsRequest();
    return organizations.items;
  };

  const getProjects = async (organizationId: number) => {
    const projects = await getProjectsRequest(organizationId);
    return projects;
  };

  return { getOrganizations, getProjects };
};
